import { createQueryData } from '../helpers/createQueryData';

const endPoint =
  'Acceptance/acceptance_get_available_stage_address_life_cycle_by_address_id';

const { useQuery } = createQueryData({ endPoint });

const useRoomStagesQuery = ({ params: { addressId } = {}, options }) => {
  return useQuery({
    params: { addressId },
    options: {
      enabled: Boolean(addressId),
      staleTime: 0,
      ...options,
    },
  });
};

export { useRoomStagesQuery };
